<template>
  <ButtonSnsSmall class="btn-sns--line" @click-sns-button="onClick" />
</template>

<script>
import ButtonSnsSmall from '../../../atoms/buttons/ButtonSnsSmall.vue'
export default {
  components: { ButtonSnsSmall },
  methods: {
    onClick() {
      this.$emit('click-line-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-sns--line {
  @include bg-settings(
    '../../../../../../images/buttons/line-with-background.svg',
    $line,
    100%,
    100%
  );
}
</style>
